module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_AboutBook#bk"
    }
  }, [_c('b', [_vm._v("ABOUT THIS BOOK")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_AboutMe#me"
    }
  }, [_c('b', [_vm._v("ABOUT ME")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Tips#tp"
    }
  }, [_c('b', [_vm._v("MY QUICK TIPS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#ch1"
    }
  }, [_c('b', [_vm._v("SEWING ROOM ESSENTIALS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#lev1"
    }
  }, [_vm._v("My sewing room")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#lev2"
    }
  }, [_vm._v("Sewing machines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#lev3"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#lev4"
    }
  }, [_vm._v("Fabrics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#lev5"
    }
  }, [_vm._v("Fabric terminology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#lev6"
    }
  }, [_vm._v("Wadding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#lev7"
    }
  }, [_vm._v("Interfacing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#lev8"
    }
  }, [_vm._v("Threads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#lev9"
    }
  }, [_vm._v("Toy filler for softies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#lev10"
    }
  }, [_vm._v("DIY templates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#lev11"
    }
  }, [_vm._v("Storage")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("SEWING KNOW-HOW")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Machine stitches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seams")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cutting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hems")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT   Heart pincushion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zips")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Piping")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT   Pillow cover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shirring")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free-motion embroidery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT   Shirring dress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bias binding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT   Toaster cover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appliqué")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT   Drawstring bag")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bag making")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT   Tablet case")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT   Frame purse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT   Tote bag")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pleating and pin tucks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT   Bolster pillow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quilting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT   Machine mat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#lev35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dressmaking")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("INDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img-004.1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 69
// module chunks = 0